// ANCHOR Base
import {
  SIZE, ROLE, Modal, ModalBody,
} from 'baseui/modal';

// ANCHOR Model
import { useViewSubmissionModalVisibilityStateAndHide } from '@lyon/scoped-models/answer/ViewSubmissionModalVisibility';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonViewAnswerFormBody } from './LyonViewAnswerFormBody';

// ANCHOR Styles
import { MODAL } from './styles';

export const LyonViewAnswerForm = constant(() => {
  const [opened, close] = useViewSubmissionModalVisibilityStateAndHide();

  return (
    <Modal
      isOpen={opened}
      size={SIZE.full}
      onClose={close}
      role={ROLE.dialog}
      animate
      closeable
      overrides={MODAL}
    >
      <ModalBody>
        <LyonViewAnswerFormBody />
      </ModalBody>
    </Modal>
  );
});
